import { createComponent } from '@carvana/merch-components';
import { ElementWithProps } from '@carvana/merch-components/dist';
import cx from 'classnames';

export const ColorSwatch = createComponent('span', {
  className: 'block h-[12px] w-[12px] rounded-full border border-border-weak'
});

export const ColorSwatchesContainer = createComponent('div', {
  className: 'flex items-center gap-xs sm:mt-lg'
});

export const Content = createComponent('div', {
  className: 'flex flex-col gap-lg sm:grid sm:grid-rows-subgrid sm:gap-y-0'
});

export const Description = createComponent('p', {
  className: 'text-text-default t-body-sm sm:mt-lg'
});

export const HighlightItem = createComponent('li', {
  className: 'py-xs ml-2xl'
});

export const HighlightsList = createComponent('ul', {
  className:
    'flex flex-col gap-sm list-disc list-outside t-body-sm text-text-default'
});

export const HighlightsSection = createComponent('div', {
  className: 'flex flex-col gap-sm border-y border-border-subtle py-md sm:mt-lg'
});

export const Label = createComponent('span', {
  className: 'text-text-strong t-label-sm'
});

export const PriceAdd = createComponent<
  ElementWithProps<{ disabled: boolean }>
>('span', ({ disabled }) => ({
  className: cx(
    'shrink-0 t-heading-md',
    disabled ? 'text-text-disabled' : 'text-text-strong'
  )
}));

export const UpgradesSection = createComponent('div', {
  className: 'flex flex-col gap-sm sm:mt-lg'
});

export const ViewHighlightsRow = createComponent('div', {
  className: 'border-b border-border-subtle pb-lg sm:mt-lg'
});
